import React, { useState } from "react";
import { toast } from "react-toastify";
import "./Identification.css";
import Upload from "../../../../assets/Upload.svg";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Loader from "react-loader-spinner";
import {
  ButtonGroup,
  colors,
  // StyledTextInputBankTransfer,
  StyledBankTransferFormButton,
} from "../../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "../../../../../Formik/BankDetailsInput";
import { $api } from "../../../../../../../helpers/$api";
import { API_URL } from "../../../../../../../helpers/config";

const Identification = () => {
  const [filename, setFilename] = useState("Upload Valid ID");
  const [file, setFile] = useState(null);

  return (
    <div className="identification-section">
      <div className="identificationPage">
        <h1>Means of Identification</h1>
        <p>You must add a valid means of identification to get verified.</p>
      </div>
      <div className="identification-upload">
        <div>
          <label
            htmlFor="upload"
            style={{
              display: "flex",
              cursor: "pointer",
            }}
          >
            <img src={Upload} alt="upload" className="upload" />
          </label>
          <input
            type="file"
            id="upload"
            onChange={(event) => {
              const [file] = event.target.files;
              setFilename(file.name);
              setFile(file);
              console.log(event, event.target.value, event.target.files);
            }}
            required
            style={{ display: "none" }}
          />
          <p
            style={{
              marginTop: "10px",
            }}
          >
            {filename}
          </p>
        </div>
      </div>
      <div>
        <Formik
          initialValues={{
            cardnumber: "",
          }}
          onSubmit={async (values, { setSubmitting, setFieldError }) => {
            try {
              if (!file) {
                setFieldError("cardnumber", "Upload a valid id");
                return;
              }

              const formData = new FormData();
              formData.append("document", [file]);
              formData.append("id_number", values.cardnumber);

              await $api.user.request({
                method: "POST",
                url: `${API_URL}/user/idcard/upload`,
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
              });
              toast.success("Document and id saved successfully");
            } catch (error) {
              toast.error(`error saving document and id - ${error.message}`);
            } finally {
              setSubmitting(false);
            }
          }}
          validationSchema={Yup.object({
            cardnumber: Yup.string().required(
              "Id Card Number Field is Required"
            ),
          })}
        >
          {({ isSubmitting }) => (
            <Form>
              <BankTranferDetailsTextInput
                name="cardnumber"
                type="tel"
                placeholder="ID Card Number"
              />
              <p className="Upload-note">
                NB: means of identification should be government issued which
                can be driver’s license, international passport, voter’s card
                etc
              </p>

              <ButtonGroup>
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Upload ID
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>

        {/* <input
          type="text"
          className="upload-input"
        /> */}
      </div>
    </div>
  );
};

export default Identification;
